import React, { Fragment, useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import ContentfulFields from 'components/ContentfulFields';
import { isAcquisitionDomain } from 'utils/domainHelper';
import PromotionBanner from 'containers/QuickShop/PromotionBanner/Loadable';
import quickShopContent from 'containers/QuickShop/quickShopContent';
import {
  selectPromotionId,
  selectPromotionLoading,
} from 'containers/Cart/selectors';
import PromotionAppliedDialog from 'components/Dialogs/PromotionAppliedDialog/Loadable';
import { selectIsAuthenticated } from 'containers/Authentication/selectors';
import { loadProductCategories as loadProductCategoriesRequest } from 'containers/PrimoProducts/actions';

const LandingPage = ({
  site,
  promotionId,
  isPromotionLoading,
  loadProductCategories,
}) => {
  const {
    components: { page },
  } = site;

  const slug = get(page, 'slug', '');

  useEffect(() => {
    loadProductCategories();
  }, []);

  const isHomepage = ['acquisition-home', 'acquisition-office'].includes(slug);
  const promotionApplied = !!promotionId;
  const [
    openRedeemedPromotionDialog,
    setRedeemedPromotionDialogStatus,
  ] = useState(false);
  const showRedeemDialog = () => {
    setRedeemedPromotionDialogStatus(true);
  };

  return (
    <Fragment>
      {isHomepage && isAcquisitionDomain() && (
        <PromotionBanner
          isCartLoading={false}
          promotionApplied={promotionApplied}
          showRedeemDialog={showRedeemDialog}
          content={quickShopContent}
        />
      )}
      {get(page, 'contentModules', []).map((banner) => (
        <ContentfulFields
          type={get(banner, 'sys.contentType.sys.id', '')}
          document={banner}
          key={banner.sys.id}
          showRedeemDialog={showRedeemDialog}
        />
      ))}
      <PromotionAppliedDialog
        open={openRedeemedPromotionDialog}
        setStatus={setRedeemedPromotionDialogStatus}
        promotionLoading={isPromotionLoading}
      />
    </Fragment>
  );
};

LandingPage.propTypes = {
  site: PropTypes.object,
  isPromotionLoading: PropTypes.bool,
  loadProductCategories: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  loadProductCategories: loadProductCategoriesRequest,
};

const mapStateToProps = createStructuredSelector({
  promotionId: selectPromotionId(),
  isPromotionLoading: selectPromotionLoading(),
  isAuthenticated: selectIsAuthenticated(),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withRouter, withConnect)(LandingPage);
